import { useCallback, useEffect, useState } from 'react';

import { entrar, consultarSessao, sair } from '../api/authAdmin';
import type { CredenciaisLogin, SessaoAdmin } from './types';

export type EstadoSessao =
    | { tipo: 'verificando' }
    | { tipo: 'anonimo'; indisponivel: boolean }
    | { tipo: 'autenticado'; sessao: SessaoAdmin };

export function useSessao() {
    const [estado, setEstado] = useState<EstadoSessao>({ tipo: 'verificando' });

    const verificar = useCallback(() => {
        setEstado({ tipo: 'verificando' });
        void consultarSessao()
            .then((sessao) => setEstado({ tipo: 'autenticado', sessao }))
            .catch((erro: unknown) => {
                const status = typeof erro === 'object' && erro !== null && 'status' in erro
                    ? (erro as { status?: number }).status
                    : undefined;
                setEstado({ tipo: 'anonimo', indisponivel: status !== 401 });
            });
    }, []);

    useEffect(() => { verificar(); }, [verificar]);

    const entrarCom = useCallback(async (credenciais: CredenciaisLogin) => {
        const sessao = await entrar(credenciais);
        setEstado({ tipo: 'autenticado', sessao });
        return sessao;
    }, []);

    const sairDaSessao = useCallback(async () => {
        if (estado.tipo !== 'autenticado') return;
        await sair(estado.sessao.csrfToken);
        setEstado({ tipo: 'anonimo', indisponivel: false });
    }, [estado]);

    return { estado, entrarCom, sairDaSessao, tentarNovamente: verificar };
}
